import 'css-chunksrc/client/scenes/costProfileEdition/costHistory/styles.scss';export default {
  "costHistory": "_costHistory_1lnpv_1",
  "list": "_list_1lnpv_7"
};